import { Room } from 'livekit-client'
import { MediaDescription, parse, write } from 'sdp-transform'

// see https://github.com/livekit/livekit/issues/970
// and https://gist.github.com/mmckegg/df597f95fa7b608fb2b232557ad1522f

export default function applyLivekitStereoPatch(room: Room) {
    applyPatch(room)

    room.engine.on('transportsCreated', () => {
        if (room) {
            applyPatch(room)
        }
    })
}

function applyPatch(room: Room) {
    /* @ts-ignore*/
    const subscriber = room.engine.subscriber
    if (!subscriber) return false

    // update createAndSetAnswer on subscriber with call to ensureStereoAudio
    subscriber.createAndSetAnswer = async function (): Promise<RTCSessionDescriptionInit> {
        const answer = await this.pc.createAnswer()
        const sdpParsed = parse(answer.sdp ?? '')
        sdpParsed.media.forEach((media) => {
            if (media.type === 'audio') {
                ensureAudioNack(media)
                ensureStereoAudio(media) // << added code
            }
        })
        await (this as any).setMungedLocalDescription(answer, write(sdpParsed))
        return answer
    }

    // port existing function:
    function ensureAudioNack(
        media: {
            type: string
            port: number
            protocol: string
            payloads?: string | undefined
        } & MediaDescription
    ) {
        let opusPayload = 0
        media.rtp.some((rtp): boolean => {
            if (rtp.codec === 'opus') {
                opusPayload = rtp.payload
                return true
            }
            return false
        })

        if (opusPayload > 0) {
            if (!media.rtcpFb) {
                media.rtcpFb = []
            }

            if (!media.rtcpFb.some((fb) => fb.payload === opusPayload && fb.type === 'nack')) {
                media.rtcpFb.push({
                    payload: opusPayload,
                    type: 'nack',
                })
            }
        }
    }
    return true
}

// added code:
function ensureStereoAudio(media: MediaDescription) {
    for (const attributes of media.fmtp) {
        if (attributes.payload == 111 && !attributes.config.includes('stereo=')) {
            attributes.config += ';stereo=1'
        }
        if (attributes.payload == 111 && !attributes.config.includes('sprop-stereo=')) {
            attributes.config += ';sprop-stereo=1'
        }
        if (attributes.payload == 111 && !attributes.config.includes('maxaveragebitrate=')) {
            attributes.config += ';maxaveragebitrate=192000'
        }
    }
}
